export const DEFAULT_PUBLIC_ORIGIN = 'https://xn--80adjkr6adm9b.xn--p1ai';

// Only configuration supplies this value; never derive it from the request Host.
export const normalizePublicOrigin = (value?: string): string => {
  try {
    const url = new URL(value || DEFAULT_PUBLIC_ORIGIN);
    if (
      url.protocol !== 'https:' || url.username || url.password ||
      url.hostname.startsWith('origin.') || url.pathname !== '/' ||
      url.search || url.hash
    ) return DEFAULT_PUBLIC_ORIGIN;
    return url.origin;
  } catch {
    return DEFAULT_PUBLIC_ORIGIN;
  }
};

export const PUBLIC_ORIGIN = normalizePublicOrigin(
  process.env.REACT_APP_SEO_PUBLIC_ORIGIN,
);

export const normalizeSeoPath = (value: string): string => {
  const path = value.split(/[?#]/)[0].replace(/\\/g, '/').replace(/\/{2,}/g, '/');
  const rooted = path.startsWith('/') ? path : `/${path}`;
  return new URL(rooted, DEFAULT_PUBLIC_ORIGIN).pathname.replace(/\/+$/, '') || '/';
};

export const buildCanonicalUrl = (path: string, origin = PUBLIC_ORIGIN): string =>
  `${normalizePublicOrigin(origin)}${normalizeSeoPath(path)}`;

export const INDEXABLE_STATIC_PATHS = ['/', '/contacts', '/restaurants', '/dostavka-i-oplata'];
export const SERVICE_PATHS = ['/profile', '/promotions', '/legal-information'];
export const SSR_RENDERABLE_SERVICE_PATHS = ['/promotions'];
const RESERVED_PATHS = [...INDEXABLE_STATIC_PATHS, ...SERVICE_PATHS, '/404', '/about', '/static', '/server'];

export const catalogSlugPath = (slug: unknown): string | null => {
  if (typeof slug !== 'string' || !/^[\p{L}\p{N}][\p{L}\p{N}_-]*$/u.test(slug)) return null;
  const path = normalizeSeoPath(`/${slug}`);
  return RESERVED_PATHS.includes(path) ? null : path;
};

export const isPublicSeoRoute = (
  path: string,
  categorySlugs: string[],
  productSlugs: string[],
): boolean => {
  const normalized = normalizeSeoPath(path);
  if (INDEXABLE_STATIC_PATHS.includes(normalized)) return true;
  return [...categorySlugs, ...productSlugs].some(
    (slug) => catalogSlugPath(slug) === normalized,
  );
};
